// Disclaimer for the creation and use of this method.
// The fouling and vessel comparison pages are really bad and had dependencies
// on features that they should not have (the Header for example ffs).
// This method is a temporary solution to commit the vessels data to the old store so the stupid
// logic behind them is not affected.
// It should be removed immediately once the new pages are refactored.

export default function commitVesselsDataToOldStore(fleet, commit) {
  const vesselsData = fleet.map((vessel) => ({
    "Vessel": vessel.vessel,
    "Group": vessel.group,
    "idVessel": vessel.idVessel,
    "Class": vessel.vesselClass,
    "IMO": vessel.IMO,
    "Fouling": vessel.fouling,
    "Consumption": vessel.consumption,
    "Date": vessel.date,
    "coordinates": [
      vessel.coordinates[0],
      vessel.coordinates[1]
    ],
    "ME_RPM": vessel.meRPM,
    "ME_Power": vessel.mePower,
    "GPS_Speed": vessel.gpsSpeed,
    "LOG_Speed": vessel.logSpeed,
    "avgDraft": vessel.avgDraft,
    "mcr": vessel.mcr,
  }));

  commit("setVesselsData", vesselsData, { root: true });
}
